import moment from 'moment';
import 'moment/locale/th';
moment.locale('th');

// Threshold to detect Buddhist Era year values (e.g., 2500+)
const BE_YEAR_THRESHOLD = 2400;

function toBE(year) {
    return year > BE_YEAR_THRESHOLD ? year : year + 543;
}

function toCE(year) {
    return year > BE_YEAR_THRESHOLD ? year - 543 : year;
}

// removed unused: convertDate, convertDateNoTime, convertDateFixTime

export function formatDate(dateString) {
    if (dateString === null || dateString === '' || dateString === undefined) {
        return null;
    }

    // Use moment to parse the date, supporting multiple formats
    let m = moment(dateString, ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY', 'MM/DD/YYYY', moment.ISO_8601], true);
    
    // If strict parsing failed, try non-strict parsing
    if (!m.isValid()) {
        m = moment(dateString);
    }
    
    // If still invalid, return null
    if (!m.isValid()) {
        return null;
    }

    // Convert to Buddhist Era (พ.ศ.) but avoid double-adding if input already BE
    const rawYear = m.year();
    const year = toBE(rawYear);
    const month = String(m.month() + 1).padStart(2, '0');
    const day = String(m.date()).padStart(2, '0');

    return `${day}/${month}/${year}`;
}

export function formatDateMonthYear(dateString) {
    if (dateString === null || dateString === '' || dateString === '-') {
        return null;
    }

    const date = new Date(dateString);
    date.setHours(date.getHours() - 7);

    const rawYear = date.getFullYear();
    const year = toBE(rawYear);
    const month = String(date.getMonth() + 1).padStart(2, '0');

    return `${month}/${year}`;
}

export function formatDateCheque(dateString) {
    if (dateString === null || dateString === '') {
        return null;
    }

    const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
    if (datePattern.test(dateString)) {
        return dateString;
    }

    const date = new Date(dateString);
    if (isNaN(date)) {
        return null;
    }

    const rawYear = date.getFullYear();
    const year = toBE(rawYear);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
}

// removed unused: formatDatetax

export function formatDateAndTime(dateString) {
    if (!dateString) {
        return null;
    }

    let date = new Date(dateString);
    date = new Date(date.getTime() - 7 * 60 * 60 * 1000);

    const rawYear = date.getFullYear();
    const year = toBE(rawYear);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

// สำหรับ field ที่ DB เก็บเป็น UTC จริงๆ เช่น Last_STC_Date จาก mobile (ไม่ต้อง offset)
export function formatUTCDateAndTime(dateString) {
    if (!dateString) {
        return null;
    }

    const date = new Date(dateString);
    const rawYear = date.getFullYear();
    const year = toBE(rawYear);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

// ฟังก์ชันสำหรับแปลงวันที่จาก string format (dd-mm-yyyy) เป็น date format (YYYY-MM-DD 00:00:00.000)
export function formatStringDateToDate(dateString) {
  // ตรวจสอบว่า dateString เป็นค่าว่าง, null หรือไม่
  if (!dateString || typeof dateString !== 'string') {
    return null;
  }

  // ตรวจสอบรูปแบบวันที่ที่คาดหวัง (dd-mm-yyyy)
  const dateParts = dateString.split('-');
  if (dateParts.length !== 3) {
    return null;
  }

  // แยกวัน เดือน ปี จากสตริงวันที่
  const [day, month, buddhistYear] = dateParts;

  // ตรวจสอบความถูกต้องของวัน, เดือน, ปี
  if (
    !day ||
    !month ||
    !buddhistYear ||
    isNaN(day) ||
    isNaN(month) ||
    isNaN(buddhistYear)
  ) {
    return null;
  }

  // แปลงพุทธศักราชเป็นคริสต์ศักราช
  const christianYear = parseInt(buddhistYear, 10) - 543;

  // ตรวจสอบความถูกต้องของปีคริสต์ศักราช
  if (isNaN(christianYear) || christianYear < 0) {
    return null;
  }

  // จัดรูปแบบวันที่เป็น "YYYY-MM-DD 00:00:00.000"
  const formattedDate = `${christianYear}-${month.padStart(
    2,
    '0'
  )}-${day.padStart(2, '0')} 00:00:00.000`;

  return formattedDate;
}

// ฟังก์ชันเพื่อใช้กับ handleChangeDateMaster ผลลัพธ์ที่ Return คือ "13-08-2567"
export function formatDateOnChange(dateString) {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date');
  }

  let year = date.getFullYear();
  // ตรวจสอบว่าเป็นปี ค.ศ. หรือ พ.ศ.
    if (year < BE_YEAR_THRESHOLD) {
    year += 543; // แปลงเป็นปี พ.ศ.
  }

  return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${year}`;
}

export function formatDateTime(date) {
    const padZero = (number, length) => number.toString().padStart(length, '0');

    const year = date.getFullYear().toString().slice(2);
    const month = padZero(date.getMonth() + 1, 2);
    const day = padZero(date.getDate(), 2);
    const hours = padZero(date.getHours(), 2);
    const minutes = padZero(date.getMinutes(), 2);
    const seconds = padZero(date.getSeconds(), 2);
    const milliseconds = padZero(date.getMilliseconds(), 3);

    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}

// removed unused: formatThaiDate

export function formatThaiDateUiToDate(date) {
    if (!date || typeof date !== 'string') {
        return null;
    }

    const [datePart, timePart] = date.split(' ');

    if (!datePart) {
        return null;
    }

    const [day, month, year] = datePart.split('-');

    if (!day || !month || !year) {
        return null;
    }

    const christianYear = toCE(Number(year));

    if (isNaN(christianYear) || christianYear < 0) {
        return null;
    }

    if (timePart) {
        // input คือเวลา Bangkok (UTC+7) แปลงเป็น UTC ก่อนส่ง server
        const localDate = new Date(`${christianYear}-${month}-${day}T${timePart}`);
        const pad = (n) => String(n).padStart(2, '0');
        return `${localDate.getUTCFullYear()}-${pad(localDate.getUTCMonth() + 1)}-${pad(localDate.getUTCDate())} ${pad(localDate.getUTCHours())}:${pad(localDate.getUTCMinutes())}:${pad(localDate.getUTCSeconds())}.000`;
    }
    return `${christianYear}-${month}-${day} 00:00:00.000`;
}

export function getCurrentYearMonth() {
    const currentYear = (new Date().getFullYear() + 543).toString().slice(-2);
    const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
    return { currentYear, currentMonth };
}

export function getCreateDateTime() {
    const today = new Date();
    const year = today.getFullYear() + 543;
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const formattedNewDate = `${day}-${month}-${year}`;
    const formattedTime = today.toTimeString().split(' ')[0];
    return `${formattedNewDate} ${formattedTime}`;
}

export function setCreateDateTime(date) {
    if (date === null) {
        return null;
    }

    if (date === '') {
        return '';
    }

    const today = new Date(date);

    const year = today.getUTCFullYear() + 543;
    const day = today.getUTCDate().toString().padStart(2, '0');
    const month = (today.getUTCMonth() + 1).toString().padStart(2, '0');
    const formattedNewDate = `${day}-${month}-${year}`;

    const hours = today.getUTCHours().toString().padStart(2, '0');
    const minutes = today.getUTCMinutes().toString().padStart(2, '0');
    const seconds = today.getUTCSeconds().toString().padStart(2, '0');
    const formattedTime = `${hours}:${minutes}:${seconds}`;

    return `${formattedNewDate} ${formattedTime}`;
}

// Format: พฤหัสบดี 09 ตุลาคม 68
export function formatThaiDayMonthShortYear(input) {
    if (!input) return '';

    let m;
    // Handle Date object directly
    if (input instanceof Date) {
        m = moment(input);
    } else if (typeof input === 'string') {
        const trimmed = input.trim();
        // Case: 'DD-MM-YYYY HH:mm:ss' (likely BE year)
        const parts = trimmed.split(' ');
        const datePart = parts[0] || trimmed;
        const dmY = datePart.split('-');
        if (dmY.length === 3 && dmY[0].length === 2 && dmY[1].length === 2 && dmY[2].length === 4) {
            const dd = parseInt(dmY[0], 10);
            const mm = parseInt(dmY[1], 10);
            let yyyy = parseInt(dmY[2], 10);
            // If BE (e.g., 2568), convert to CE for moment construction
            if (yyyy > 2200) yyyy = yyyy - 543;
            m = moment({ year: yyyy, month: mm - 1, date: dd });
        } else {
            // Fallback for ISO/other parseable strings
            m = moment(trimmed);
        }
    } else {
        return '';
    }

    if (!m || !m.isValid()) return '';

    const dayName = m.format('dddd');
    const day = m.format('DD');
    const monthName = m.format('MMMM');
    const yearBEshort = ((m.year() + 543) % 100).toString().padStart(2, '0');
    return `${dayName} ${day} ${monthName} ${yearBEshort}`;
}
